import React from 'react';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { Navigate } from '@common/components';
import { useCurrentMembership } from '@identity/hooks';

export function TemplatesLandingPage() {
  const currentMembership = useCurrentMembership();

  setBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: 'Templates',
      path: '/works/admin/templates',
    },
  ]);

  const canShowAdminStaffingRequestTemplates =
    currentMembership.canShowAdminStaffingRequestTemplates || false;
  const canShowAdminWorksListTemplates =
    currentMembership.canShowAdminWorksListTemplates || false;

  return (
    <>
      {canShowAdminWorksListTemplates && (
        <Navigate to="/works/admin/templates/compliance-list" />
      )}
      {canShowAdminStaffingRequestTemplates && (
        <Navigate to="/works/admin/templates/staffing-request" />
      )}
    </>
  );
}
